import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Badge, tokens } from '@hotjar/hotsauce';

import { ALL_HIGHLIGHTS_ID } from '@hotjar/webapp/domains/collections/model';
import { getRoute } from '@hotjar/webapp/utils/routing';
import * as Routes from '@hotjar/webapp/constants/routes';
import { useCurrentSiteId } from '@hotjar/site';

import { useUnseenHighlightsCount } from './use-unseen-highlights-count';

const StyledBadge = styled(Badge)`
  margin-left: ${tokens.spacer.x1};
`;

interface HighlightsSidebarItemProps {
  NavItem: (props: {
    children: React.ReactNode;
    text: string;
    path: string;
    icon: 'lightbulb';
    onClick: () => void;
    rootConfigName: string;
  }) => JSX.Element;
}

export function HighlightsSidebarItem({ NavItem }: HighlightsSidebarItemProps): JSX.Element | null {
  const { t } = useTranslation();

  const currentSiteId = useCurrentSiteId();
  const unseenHighlightsCount = useUnseenHighlightsCount(currentSiteId);

  if (currentSiteId === null) {
    return null;
  }

  const path = getRoute(Routes.HIGHLIGHTS.LIST.path, {
    siteId: currentSiteId,
    collectionId: ALL_HIGHLIGHTS_ID,
  });

  return (
    <NavItem
      text={t('highlights:sidebar-label')}
      path={path}
      icon="lightbulb"
      onClick={unseenHighlightsCount.reset}
      rootConfigName="highlights"
    >
      {t('highlights:sidebar-label')}
      {typeof unseenHighlightsCount.value !== 'undefined' && unseenHighlightsCount.value > 0 ? (
        <StyledBadge color={tokens.color.text_warning} kind="custom" size="s">
          {String(unseenHighlightsCount.value)}
        </StyledBadge>
      ) : null}
    </NavItem>
  );
}
